export default {"src":"/_next/static/media/Group-25834.340b3e25.svg","height":130,"width":130};